import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private supportedLanguages = ['en', 'ar', 'it', 'tr'];
  currentDirection: 'ltr' | 'rtl' = 'ltr';
  constructor(private translate: TranslateService) {
    const savedLanguage = localStorage.getItem('language') || 'en';
    this.setLanguage(savedLanguage); // Initialize with saved or default language
    this.translate.use(savedLanguage);
  }

  getLanguages() {
    return this.supportedLanguages.map((lang) => ({
      code: lang,
      label: this.translate.instant(lang.toUpperCase()),
    }));
  }

  setLanguage(language: string): void {
    if (this.supportedLanguages.includes(language)) {
      this.translate.use(language);
      localStorage.setItem('language', language);
      this.currentDirection = language === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.dir = this.currentDirection;
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }
}
